import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/production/declarations")({
  staticData: {
    permission: PERMISSIONS.PRODUCTION.DECLARATIONS.VIEW,
  },
  component: () => <Outlet />,
});
